import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import type { IVector2 } from '@seddi/math-v2';
import type { TSceneEx } from '@seddi/ui-three-viewer';

// full scene payload out of Redux

let sceneStateInternal: TSceneEx | null = null;

export const getScene = () => {
  return sceneStateInternal;
};

export const setScene = (scene: TSceneEx | null) => {
  sceneStateInternal = scene;
};

const ResolutionDef: IVector2 = { x: 1024, y: 1024 };

// scene state

export type TAppState = {
  resolution: IVector2;
  sceneIsLoading: boolean;
  // simplified scene state propagation
  sceneVersion: number;
};

const initialState: TAppState = {
  resolution: { ...ResolutionDef },
  sceneIsLoading: false,
  sceneVersion: 0,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    clear: state => {
      state.resolution = { ...ResolutionDef };
      state.sceneIsLoading = false;
      state.sceneVersion = 0;
    },
    setResolution: (state, action: PayloadAction<IVector2>) => {
      state.resolution = action.payload;
    },
    setSceneIsLoading: (state, action: PayloadAction<boolean>) => {
      state.sceneIsLoading = action.payload;
    },
    updateScene: state => {
      state.sceneVersion = state.sceneVersion + 1;
    },
  },
});

export const { clear, setResolution, setSceneIsLoading, updateScene } = appSlice.actions;

export const appReducer = appSlice.reducer;
